import { Dialog, DialogTitle, Box } from "@mui/material";
import "./styles.css";
import audioLocationPermissionsImg from "../../assets/audio_location_permissions_img.svg";
import { useTranslationSetup } from "../../utils/useTranslationSetup.js";
import LockIcon from "@mui/icons-material/Lock";
import TuneIcon from "@mui/icons-material/Tune";
import MicNoneIcon from "@mui/icons-material/MicNone";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import ToggleOffOutlinedIcon from "@mui/icons-material/ToggleOffOutlined";
import page_info from "../../assets/page_info.png";

const GrantPermissionsStepsDialog = ({ isDialogOpen }) => {
  const { t } = useTranslationSetup();

  return (
    <Dialog className="grant-permissions-steps-dialog" open={isDialogOpen}>
      <DialogTitle className="grant-permissions-steps-dialog-title">
        <Box className="grant-permissions-steps-dialog-heading">
          {t("you_havent_allowed_access_to_location_mic")}
        </Box>
        <Box>
          <img
            src={audioLocationPermissionsImg}
            alt="audio-location-permissions-img"
          />
        </Box>
        <Box className="grant-permissions-steps-dialog-content">
          {t("reload_the_screen_after_following_steps")}
        </Box>
        <Box className="grant-permissions-steps">
          {t("click_on")}
          <LockIcon className="lock-icon" />
          {"/"}
          <img src={page_info} alt="page_info" className="page-info-img" />
          {t("at_the_top_left_corner")} &gt; {t("click_on")} {t("permissions")}
          <TuneIcon className="tune-icon" />
          &gt; {t("click_on_button")}
          {/* &gt; {t("microphone")} */}
          <ToggleOffOutlinedIcon className="toggle-off-outlined-icon" />
          {t("against Microphone")}
          <MicNoneIcon className="toggle-off-outlined-icon" />/ {t("location")}
          <LocationOnOutlinedIcon className="toggle-off-outlined-icon" />
          &gt; {t("click_outside_pop-up")} &gt; {t("reload")}
        </Box>
      </DialogTitle>
    </Dialog>
  );
};

export default GrantPermissionsStepsDialog;
